module.exports = __webpack_public_path__ + "img/person.e8c00b50.png";